'use client';
import { RootState } from '@/redux/store';
import { BackArrow } from '@repo/ui';
import { useSelector } from 'react-redux';

/**
 * Shared back arrow pointed at the previous step of the onboarding flow; hidden on the first step and on the
 * final review, where going back isn't allowed.
 *
 * @return {React.JSX.Element} The rendered back arrow, or nothing.
 */
export const FlowBackArrow = () => {
  const steps = useSelector((state: RootState) => state.flowdata.steps);
  const currentStepName = useSelector((state: RootState) => state.navigationdata.currentStep);
  const currentStep = steps?.find((s) => s.name === currentStepName);
  const previousStep = currentStep && steps?.[steps?.indexOf(currentStep) - 1]?.name;
  const forceHideBackArrow = currentStepName === 'REVIEW_AND_SUBMIT';

  return previousStep && !forceHideBackArrow ? <BackArrow route={`/flow/${previousStep}`} /> : null;
};
